import { LOCALES } from './locale';

export const GRAVE_CONFIG = [
  { label: LOCALES.SECTION, field: 'section' },
  { label: LOCALES.BLOCK, field: 'block' },
  { label: 'Type', field: 'type' },
];

export const MAUSOLEUM_CONFIG = [
  { label: 'Bank', field: 'bank' },
  { label: 'Row', field: 'row' },
  { label: 'Tier', field: 'tier' },
  { label: 'Type', field: 'type' },
];
